export interface DropDownDto
{
    getTitle(): string;
    getId():string;
    getIconName():string;
}

export class DropDownDtoImpl implements DropDownDto
{
    private title: string;
    private id: string;
    private iconName: string;
   

    getTitle():string
    {
        return this.title;
    }

    setTitle(title: string)
    {
        this.title = title;
    }
     
    getId():string
    {
        return this.id;
    }

    setId(id:string)
    {
        this.id = id;
    }

    getIconName():string
    {
        return this.iconName;
    }

    setIconName(iconName:string)
    {
        this.iconName = iconName;
    }

}    


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/dropdown/dropdowndto.ts